import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getTipoServidor, cadastrarTipoServidor, alterarTipoServidor, excluirTipoServidor } from '../../../api';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
var TiposServidoresEditar = function () {
    var services = {
        getItem: getTipoServidor,
        cadastrarItem: cadastrarTipoServidor,
        alterarItem: alterarTipoServidor,
        excluirItem: excluirTipoServidor,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.TIPOS_SERVIDORES, paginaPermissao: FUNCIONALIDADES.TIPOS_SERVIDORES, rota: ROUTES.TIPOS_SERVIDORES, services: services });
};
export default TiposServidoresEditar;
